import { render, staticRenderFns } from "./add-product.modal.vue?vue&type=template&id=0fc3f5f0&scoped=true"
import script from "./add-product.modal.vue?vue&type=script&lang=js"
export * from "./add-product.modal.vue?vue&type=script&lang=js"
import style0 from "./add-product.modal.vue?vue&type=style&index=0&id=0fc3f5f0&prod&lang=scss&scoped=true"
import style1 from "./add-product.modal.vue?vue&type=style&index=1&id=0fc3f5f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc3f5f0",
  null
  
)

export default component.exports